import { render, staticRenderFns } from "./WordingCreate.vue?vue&type=template&id=55b33761&scoped=true&"
import script from "./WordingCreate.vue?vue&type=script&lang=js&"
export * from "./WordingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b33761",
  null
  
)

export default component.exports